export enum SessionTokens {
  CURRENT_USER_INFO = "_U53r_!nfO",
  IS_OTP_ALLOWED = 'otpAllowed'
}